import { render, staticRenderFns } from "./UserDrawer.vue?vue&type=template&id=a7e48b78&scoped=true"
import script from "./UserDrawer.vue?vue&type=script&lang=js"
export * from "./UserDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e48b78",
  null
  
)

export default component.exports